<template>
	<div>
		<h5 class="info-text">Отправка презентации</h5>

		<div>
			<form class="send-form">

				<div class="link-row mb-3">
					<div class="col-sm col-xs-12 px-0">
						<a :href="linkText" target="_blank" class="d-inline-block py-2" ref="c2c" style="font-size: 0px; opacity: -0.5;">
						     {{$GVO.endpoint_domen+linkText}} 
						</a>
						<a :href="$GVO.endpoint_domen+linkText+'?isagent=true'" target="_blank">
						<base-button class="btn-simple btn-prez">
							<i class="tim-ic ic-eye"></i> Посмотреть презентацию 
						</base-button>
						</a>
					</div>
				</div>

				<div class="select-row mb-3">
					<div class="col px-0">
						<label for="">Способ отправки</label>
						<el-select 
							class="col-md px-0 select-primary"
							v-model="sendType" placeholder="Выбрать способ отправки"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="item in arrSendType"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
				</div>

				<div v-if="sendType == 'Скопировать ссылку'">
					<p>Скопируйте ссылку, отправьте ее клиенту и завершите задачу</p>
					<div class="link-row justify-content-center mt-3">
						<base-button type="success" simple @click="c2c()" ><i class="tim-icons icon-link-72 mr-2"></i>Копировать</base-button>
					</div>
				</div>
				<div v-if="sendType == 'Отправить на почту'">
					<p>Выберите почту, отправьте презентацию и после этого завершите задачу</p>
					<div class="contacts-row mt-3">
						<div class="col px-0">
							<label for="">Отправить по почте:</label>
							<el-select v-if="emails.length>0"
								class="col-md px-0 select-primary"
								v-model="sendToMail" filterable placeholder="Выбрать почту"
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="item in emails"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-input v-else 
								placeholder="Напишите почту" 
								v-model="sendToMail" 
								type="email" 
								v-validate="modelValidations.email"
							></base-input>
						</div>
					</div>
					<div class="message-row mt-3 px-1">
						<textarea 
							class="form-control"
							placeholder="Текст сообщения"
							ref="saveInput"						
							v-model="strNote">	
						</textarea>	
					</div>
				</div>
				<div v-if="sendType == 'Отправить в соц. сеть'">
					<p>Данный пункт работает, если на устройстве установлен соответствующий мессенджер.
						В ином случае, рекомендуется выбрать другой способ отправки: по почте либо просто скопировать ссылку.
					</p>
					<div class="message-row mt-3 px-1">
						<textarea 
							class="form-control"
							placeholder="Текст сообщения"
							ref="saveInput"						
							v-model="strNote">	
						</textarea>	
					</div>
				</div>
				
				<div class="send-footer mt-3" >
					<base-button v-if="sendType == 'Отправить на почту'" type="success" simple @click="SendPres()" class="mr-2">Отправить на почту</base-button>

					<div class="socialBlk" v-if="sendType == 'Отправить в соц. сеть'">
						<a type="button" target="_blank" :href="GetShareUrl('telegram')"  class="btn btn-icon btn-simple btn-primary btn-telegram">
							<i class="fab fa-telegram-plane"></i>
						</a>
						<!--
						<a type="button" target="_blank" :href="GetShareUrl('viber')" class="btn btn-icon btn-simple btn-viber">
							<i class="fab fa-viber"></i>
						</a>
						-->
						<a type="button" target="_blank" :href="GetShareUrl('whatsapp')" class="btn btn-icon btn-simple btn-success btn-whatsapp">
							<i class="fab fa-whatsapp"></i>
						</a>
						<a type="button" target="_blank" :href="GetShareUrl('skype')" class="btn btn-icon btn-simple btn-primary btn-skype">
							<i class="fab fa-skype"></i>
						</a>
						<a type="button" target="_blank" :href="GetShareUrl('vk')" class="btn btn-icon btn-simple btn-primary">
							<i class="fab fa-vk"></i> 
						</a>
						<a type="button" target="_blank" :href="GetShareUrl('fb')" class="btn btn-icon btn-simple btn-facebook">
							<i class="fab fa-facebook-f"> </i>
						</a>
					</div>
				</div>
			</form>
			<!--div v-else class="">
				<a href="">Предварительный просмотр</a>
			</div-->
		</div>
	</div>
</template>
<script>
// import ReInputContact from "src/our_components/ReInputContact.vue";
import { Select, Option } from 'element-ui';
// import { BaseCheckbox } from 'src/components/index';
// import { BaseSwitch } from 'src/components/index';
// import ReShowClientMobile from 'src/our_components/ReShowClientMobile.vue';

export default {
	components: {  
		// BaseCheckbox,   
		// BaseSwitch, 	
		[Option.name]: Option,
		[Select.name]: Select,
		// ReInputContact,
		// ReShowClientMobile,
	},
	props: {
		masContacts: Array,
		linkText: {
			type: String,
			default: 'Презентация не сформирована'
		},
	},
  	data() {
		return {
			bIsSend: false, 
			sendToMail: '',
			strNote: '',
			emails: [],
			modelValidations: {
				email: {
					required: true,
					email: true
				},
			},
			sendType: '',
			arrSendType: [
				{id:0, value:'Скопировать ссылку', label: 'Скопировать ссылку'},
				{id:1, value:'Отправить на почту', label: 'Отправить на почту'},
				{id:2, value:'Отправить в соц. сеть', label: 'Отправить в соц. сеть'}
			],
		};
	  },
	watch: {
		masContacts(val){
			this.prepareEmails();
		}
	},
	methods: {
		GetShareUrl(strType){
			let strRet = '';
			switch (strType) {
				case 'telegram':
					strRet = 'https://t.me/share/url?url='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+'&text='+this.strNote;
					break;
				case 'viber':
					strRet = 'viber://forward?text='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+' '+this.strNote;
					break;
				case 'whatsapp':
					strRet = 'https://api.whatsapp.com/send?text='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+' '+this.strNote;
					break;
				case 'skype':
					strRet = 'https://web.skype.com/share?url='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+' '+this.strNote;
					break;
				case 'vk':
					strRet = 'https://vk.com/share.php?url='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+'&title='+this.strNote;
					break;
				case 'fb':
					strRet = 'https://www.facebook.com/sharer.php?src=sp&u='+this.$GVO.endpoint_domen+this.linkText+'?isagent=true'+'&title='+this.strNote;
					break;
			
				default:
					strRet = '';
					break;
			}
			return strRet;
		},
		prepareEmails(){
			this.emails = [];
			for (let i = 0; i < this.masContacts.length; i++) {
				if(this.masContacts[i].contact_group == 'email'){
					this.emails.push({value:this.masContacts[i].contact_value,label:this.masContacts[i].contact_value});
				}
			}
		},
		SendPres(){
			return this.$validator.validateAll().then(res => {
				// console.log(res);
				if(res){
					this.$emit('sendpres', {'strAddr':this.sendToMail,'strNote': this.strNote});
				} else {
					this.$GVO.showAlert('Email адрес', 'Не правильно введён Email адрес!');
				}
				return res;
			});
			//this.$emit('sendpres', {'strAddr':this.sendToMail,'strNote': this.strNote});
		},
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
		validate(){},
		selectText(element) {
			let range;
			if (document.selection) {
				// IE
				range = document.body.createTextRange();
				range.moveToElementText(element);
				range.select();
			} else if (window.getSelection) {
				range = document.createRange();
				range.selectNode(element);
				window.getSelection().removeAllRanges();
				window.getSelection().addRange(range);
			}
		},
		c2c(){
			this.selectText(this.$refs.c2c);
			document.execCommand("copy");
		}
	}
};
</script>
<style scoped>
.presentCard:not(:last-child) {margin-right: 15px;}
.presentCard-row, .btn-row, .btn-left, .btn-right {display: flex;}
.presentCard-row {flex-wrap: wrap;}
.btn-left, .btn-right {flex-wrap: wrap;}
.btn-left button {margin-right: 15px;}
.btn-row {justify-content: space-between; flex-wrap: wrap;}
.icon-print {height: 20px; width: 20px; background-image: url('/img/icons/printer.svg'); margin: 2px 0px 0px 0px;}
.presentCard, .presentInfo-row {border: 1px solid #01b0e0; border-radius: 0.2857rem; margin-bottom: 15px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 20px 0px;}
.groupBottBlock {padding-top: 10px;}
.groupPhoto {display: flex; width: 100%;}
.groupPhoto img {width: auto; height: 250px; margin: 0 auto;}
.groupBottBlock >>> button {padding: 10px 12px;}
.sendPresentation, .presentInfo-row, .flat-price, .flat-status {display: flex;}
.presentInfo-row {justify-content: space-between; flex-wrap: wrap; padding: 12px 12px 5px 12px ;}
.flat-info, .flat-checked, .send-title  {display: flex; justify-content: space-between;}
.presentInfo-row p, .flat-price, .flat-status, .flat-info p, .flat-checked {margin-right: 15px; margin-bottom: 5px;}
.sendPresentation >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.sendPresentation >>> .card-collapse {width: 100%;}
.text-crossed {text-decoration: line-through;}

/*==========send-section======================================================================*/
.send-section {padding: 15px; border: 1px solid #01b0e0; border-radius: 6px; margin-bottom: 20px;}
.send-title .btn {margin-top: -10px;}
.icon-filter{
	background-image: url('/img/icons/filter.svg');
	width:19px;
	height: 19px;
	margin-bottom: -3px;
}
.link-row, .contacts-row, .message-row, .select-row {display: flex; flex-wrap: wrap;width: 100%;}
.link-input {margin-top: 4px;}
.send-form {width: 100%;}
.send-footer {display: flex; justify-content: center;}
.send-section >>> .tab-space {padding-bottom: 0px;}
.send-section >>> .card {margin-bottom: 0px;}

.socialBlk > *{
    margin-right: 10px;
}
.btn-icon .fab{
    position: absolute;
    font-size: 1em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-12px, -12px);
    transform: translate(-12px, -12px);
    line-height: 1.5626rem;
    width: 24px;
}

@media (max-width: 768px){
	.presentCard {margin-right: 0px;}
	.presentInfo-row {flex-direction: column;}
	
}        
@media (max-width: 575px){
	.link-input {margin-top: 10px; padding: 0px;}
	.link-row .btn {width: 100%;}
	.link-row .btn-prez {margin-left: 0px;}
}
</style>
